// This needs to be updated manually because there is no way
// to know the package version at the build time.
export const ROARR_VERSION = '5.0.0';

export const ROARR_LOG_FORMAT_VERSION = '2.0.0';
